export enum BuilderActionType {
	FETCH_CABINET_STATE = 'FETCH_CABINET_STATE',
	UPDATE_CABINET_STATE = 'UPDATE_CABINET_STATE',
	STORE_CABINET_STATE = 'STORE_CABINET_STATE',
	ERROR_CABINET_STATE = 'ERROR_CABINET_STATE',

	FETCH_CABINET_CUTLIST = 'FETCH_CABINET_CUTLIST',
	UPDATE_CABINET_CUTLIST = 'UPDATE_CABINET_CUTLIST',
	STORE_CABINET_CUTLIST = 'STORE_CABINET_CUTLIST',
	ERROR_CABINET_CUTLIST = 'ERROR_CABINET_CUTLIST',

	ERROR_CABINET_CALCULATION = 'ERROR_CABINET_CALCULATION',
	FETCH_CABINET_CALCULATION = 'FETCH_CABINET_CALCULATION',
	FETCH_CABINET_BULK_MATERIAL_UPDATE = 'FETCH_CABINET_BULK_MATERIAL_UPDATE',

	FETCH_COUNTER_TOP_CALCULATION = 'FETCH_COUNTER_TOP_CALCULATION',
	STORE_COUNTER_TOP_CALCULATION = 'STORE_COUNTER_TOP_CALCULATION',
	ERROR_COUNTER_TOP_CALCULATION = 'ERROR_COUNTER_TOP_CALCULATION',

	FETCH_LOFT_STATE = 'FETCH_LOFT_STATE',
	STORE_LOFT_STATE = 'STORE_LOFT_STATE',
	ERROR_LOFT_STATE = 'ERROR_LOFT_STATE',

	FETCH_LOFT_CALCULATION = 'FETCH_LOFT_CALCULATION',
	STORE_LOFT_CALCULATION = 'STORE_LOFT_CALCULATION',
	ERROR_LOFT_CALCULATION = 'ERROR_LOFT_CALCULATION',

	FETCH_LOFT_CUTLIST = 'FETCH_LOFT_CUTLIST',
	STORE_LOFT_CUTLIST = 'STORE_LOFT_CUTLIST',
	ERROR_LOFT_CUTLIST = 'ERROR_LOFT_CUTLIST',

	FETCH_COUNTER_TOP_STATE = 'FETCH_COUNTER_TOP_STATE',
	STORE_COUNTER_TOP_STATE = 'STORE_COUNTER_TOP_STATE',
	ERROR_COUNTER_TOP_STATE = 'ERROR_COUNTER_TOP_STATE',

	FETCH_BUILDER_FC_DATA = 'FETCH_BUILDER_FC_DATA',
	STORE_BUILDER_FC_DATA = 'STORE_BUILDER_FC_DATA',

	FETCH_WALL_PANEL_STATE = 'FETCH_WALL_PANEL_STATE',
	STORE_WALL_PANEL_STATE = 'STORE_WALL_PANEL_STATE',
	ERROR_WALL_PANEL_STATE = 'ERROR_WALL_PANEL_STATE',

	FETCH_WALL_PANEL_CALCULATION = 'FETCH_WALL_PANEL_CALCULATION',
	STORE_WALL_PANEL_CALCULATION = 'STORE_WALL_PANEL_CALCULATION',
	ERROR_WALL_PANEL_CALCULATION = 'ERROR_WALL_PANEL_CALCULATION',

	FETCH_WARDROBE_STATE = 'FETCH_WARDROBE_STATE',
	STORE_WARDROBE_STATE = 'STORE_WARDROBE_STATE',
	ERROR_WARDROBE_STATE = 'ERROR_WARDROBE_STATE',

	FETCH_WARDROBE_CALCULATION = 'FETCH_WARDROBE_CALCULATION',
	STORE_WARDROBE_CALCULATION = 'STORE_WARDROBE_CALCULATION',
	ERROR_WARDROBE_CALCULATION = 'ERROR_WARDROBE_CALCULATION',

	FETCH_WARDROBE_CUTLIST = 'FETCH_WARDROBE_CUTLIST',
	STORE_WARDROBE_CUTLIST = 'STORE_WARDROBE_CUTLIST',
	ERROR_WARDROBE_CUTLIST = 'ERROR_WARDROBE_CUTLIST',

	FETCH_ELECTRICAL_CALCULATION = 'FETCH_ELECTRICAL_CALCULATION',
	STORE_ELECTRICAL_CALCULATION = 'STORE_ELECTRICAL_CALCULATION',
	ERROR_ELECTRICAL_CALCULATION = 'ERROR_ELECTRICAL_CALCULATION',

	FETCH_PROJECT_ELECTRICAL_STATE = 'FETCH_PROJECT_ELECTRICAL_STATE',
	STORE_PROJECT_ELECTRICAL_STATE = 'STORE_PROJECT_ELECTRICAL_STATE',
	ERROR_PROJECT_ELECTRICAL_STATE = 'ERROR_PROJECT_ELECTRICAL_STATE',

	UPDATE_ELECTRICAL_STATE = 'UPDATE_ELECTRICAL_STATE',

	FETCH_PAINT_BUILDER_STATE = 'FETCH_PAINT_BUILDER_STATE',
	STORE_PAINT_BUILDER_STATE = 'STORE_PAINT_BUILDER_STATE',
	ERROR_PAINT_BUILDER_STATE = 'ERROR_PAINT_BUILDER_STATE',

	FETCH_PAINT_BUILDER_CALCULATION = 'FETCH_PAINT_BUILDER_CALCULATION',
	STORE_PAINT_BUILDER_CALCULATION = 'STORE_PAINT_BUILDER_CALCULATION',
	ERROR_PAINT_BUILDER_CALCULATION = 'ERROR_PAINT_BUILDER_CALCULATION',

	FETCH_ALL_BUILDER_STATES = 'FETCH_ALL_BUILDER_STATES',
	STORE_ALL_BUILDER_STATES = 'STORE_ALL_BUILDER_STATES',
	ERROR_ALL_BUILDER_STATES = 'ERROR_ALL_BUILDER_STATES',

	FETCH_MOULDING_STATE = 'FETCH_MOULDING_STATE',
	STORE_MOULDING_STATE = 'STORE_MOULDING_STATE',
	ERROR_MOULDING_STATE = 'ERROR_MOULDING_STATE',

	FETCH_WALL_MOULDING_STATE = 'FETCH_WALL_MOULDING_STATE',
	STORE_WALL_MOULDING_STATE = 'STORE_WALL_MOULDING_STATE',
	ERROR_WALL_MOULDING_STATE = 'ERROR_WALL_MOULDING_STATE',

	FETCH_MOULDING_CALCULATION = 'FETCH_MOULDING_CALCULATION',
	STORE_MOULDING_CALCULATION = 'STORE_MOULDING_CALCULATION',
	ERROR_MOULDING_CALCULATION = 'ERROR_MOULDING_CALCULATION',

	FETCH_DRAWER_STATE = 'FETCH_DRAWER_STATE',
	STORE_DRAWER_STATE = 'STORE_DRAWER_STATE',
	ERROR_DRAWER_STATE = 'ERROR_DRAWER_STATE',

	FETCH_DRAWER_CALCULATION = 'FETCH_DRAWER_CALCULATION',
	STORE_DRAWER_CALCULATION = 'STORE_DRAWER_CALCULATION',
	ERROR_DRAWER_CALCULATION = 'ERROR_DRAWER_CALCULATION',
	FETCH_DRAWER_CUTLIST = 'FETCH_DRAWER_CUTLIST',
	STORE_DRAWER_CUTLIST = 'STORE_DRAWER_CUTLIST',
	ERROR_DRAWER_CUTLIST = 'ERROR_DRAWER_CUTLIST',

	FETCH_LEDGE_STATE = 'FETCH_LEDGE_STATE',
	STORE_LEDGE_STATE = 'STORE_LEDGE_STATE',
	ERROR_LEDGE_STATE = 'ERROR_LEDGE_STATE',

	FETCH_LEDGE_CALCULATION = 'FETCH_LEDGE_CALCULATION',
	STORE_LEDGE_CALCULATION = 'STORE_LEDGE_CALCULATION',
	ERROR_LEDGE_CALCULATION = 'ERROR_LEDGE_CALCULATION',
	FETCH_LEDGE_CUTLIST = 'FETCH_LEDGE_CUTLIST',
	STORE_LEDGE_CUTLIST = 'STORE_LEDGE_CUTLIST',
	ERROR_LEDGE_CUTLIST = 'ERROR_LEDGE_CUTLIST',

	FETCH_CURTAIN_BUILDER_STATE = 'FETCH_CURTAIN_BUILDER_STATE',
	STORE_CURTAIN_BUILDER_STATE = 'STORE_CURTAIN_BUILDER_STATE',
	ERROR_CURTAIN_BUILDER_STATE = 'ERROR_CURTAIN_BUILDER_STATE',

	FETCH_CURTAIN_BUILDER_CALCULATION = 'FETCH_CURTAIN_BUILDER_CALCULATION',
	STORE_CURTAIN_BUILDER_CALCULATION = 'STORE_CURTAIN_BUILDER_CALCULATION',
	ERROR_CURTAIN_BUILDER_CALCULATION = 'ERROR_CURTAIN_BUILDER_CALCULATION',

	UPDATE_PRE_DESIGN_BUILDER = 'UPDATE_PRE_DESIGN_BUILDER',

	SET_BUILDER_PREVIEW = 'SET_BUILDER_PREVIEW',
	CLEAR_BUILDER_PREVIEW = 'CLEAR_BUILDER_PREVIEW'
}

export enum BuilderTypes {
	FC = 'Fc',
	LOFT = 'Loft',
	WALL_PAINT = 'Wall Paint',
	WALL_PANEL = 'Wall Panel',
	PROFILE_LIGHT = 'Profile Light',
	WARDROBE = 'Wardrobe',
	CABINET = 'Cabinet',
	ELECTRICAL = 'Electrical',
	LEDGE = 'Ledge',
	CURTAIN = 'Curtain',
	MOULDING = 'Moulding',
	COUNTERTOP = 'Countertop',
	WALL_TILES = 'Wall Tiles',
	DRAWER = 'Drawer',
	CBBUILDERBASELCORNER = 'CBBUILDERBASELCORNER',
	CBBUILDERBASESINKUNIT = 'CBBUILDERBASESINKUNIT',
	CBBUILDERBASEBPO = 'CBBUILDERBASEBPO',
	WALLPAINTBUILDER = 'WALLPAINTBUILDER',
	CBBUILDERBASE = 'CBBUILDERBASE',
	COMPOSITE = 'COMPOSITE',
	WT = 'WT',
	CBBUILDERBASESINKBCUNIT = 'CBBUILDERBASESINKBCUNIT',
	CBBUILDERTALLUNIT = 'CBBUILDERTALLUNIT',
	CBBUILDERWALLROUNIT = 'CBBUILDERWALLROUNIT',
	CBBUILDERWALLBCUNIT = 'CBBUILDERWALLBCUNIT',
	WP = 'WP',
	CBBUILDERBASEHOB = 'CBBUILDERBASEHOB',
	CBBUILDERFRAMELOFT = 'CBBUILDERFRAMELOFT',
	DRAWER_CODE = 'DRAWER',
	WB = 'WB',
	CBBUILDER = 'CBBUILDER',
	CT = 'CT',
	CBBUILDERBASEBCUNIT = 'CBBUILDERBASEBCUNIT',
	WM = 'WM',
	WALLPAINTV2BUILDER = 'WALLPAINTV2BUILDER',
	GENERICBUILDER = 'GENERICBUILDER',
	PROFILE_PRODUCT = 'PROFILE_PRODUCT',
	EB = 'EB',
	CBWBFRLOFT = 'CBWBFRLOFT',
	FC_CODE = 'FC',
	LEDGE_CODE = 'LEDGE',
	CURTAIN_CODE = 'CURTAIN',
	DUMMY_BUILDER = 'Dummy Builder',
	CBBUILDERGTPTUNIT = 'CBBUILDERGTPTUNIT',
	CBBUILDERBASEPANTRY = 'CBBUILDERBASEPANTRY'
}
